export const config = {
  title: '設定時間の作業',
  header: '設定時間の作業',
  versionApp: 'アプリのバージョン設定',
  save: '保存',
}
